/**
 * Circular completion ring around the user's avatar.
 * Visible only to the profile owner.
 */
import { resolveMediaUrl } from "@/lib/api";

export default function ProfileCompletion({ percent = 0, picture, name, size = 80, showLabel = false }) {
  const stroke = 3;
  const radius = (size - stroke) / 2;
  const circ = 2 * Math.PI * radius;
  const offset = circ - (percent / 100) * circ;
  return (
    <div className="relative inline-block" style={{ width: size, height: size }}>
      <svg width={size} height={size} className="absolute inset-0 -rotate-90">
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke="hsl(var(--border))"
          strokeWidth={stroke}
          fill="none"
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke="hsl(var(--accent))"
          strokeWidth={stroke}
          fill="none"
          strokeDasharray={circ}
          strokeDashoffset={offset}
          strokeLinecap="round"
          style={{ transition: "stroke-dashoffset 0.6s ease" }}
        />
      </svg>
      <div
        className="absolute inset-1.5 overflow-hidden border border-border bg-muted flex items-center justify-center"
        style={{ borderRadius: "50%" }}
      >
        {picture ? (
          <img src={resolveMediaUrl(picture)} alt="" className="h-full w-full object-cover" />
        ) : (
          <span className="font-serif text-lg">{name?.[0] || "S"}</span>
        )}
      </div>
      {showLabel && (
        <span
          className="absolute -bottom-2 right-0 bg-accent text-accent-foreground text-[9px] uppercase tracking-[0.15em] px-1.5 py-0.5"
          data-testid="profile-completion-badge"
        >
          {percent}%
        </span>
      )}
    </div>
  );
}
